import { render, staticRenderFns } from "./ModalEditTermName.vue?vue&type=template&id=6bff4f96"
import script from "./ModalEditTermName.vue?vue&type=script&lang=js"
export * from "./ModalEditTermName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports